import { create } from 'zustand';
import type { DeviceType } from '../types';

interface AuditStoreState {
  selectedDevice: DeviceType;
  setSelectedDevice: (device: DeviceType) => void;

  auditResult: unknown | null;
  setAuditResult: (result: unknown | null) => void;

  selectedIssue: unknown | null;
  setSelectedIssue: (issue: unknown | null) => void;

  selectedIssueId: string | null;
  setSelectedIssueId: (id: string | null) => void;

  selectedIssueCategory: 'wcag' | 'best-practice' | null;
  setSelectedIssueCategory: (category: 'wcag' | 'best-practice' | null) => void;

  wcagFilter: string;
  setWcagFilter: (filter: string) => void;

  issueElement: string | null;
  setIssueElement: (element: string | null) => void;

  isDashboardVisible: boolean;
  setIsDashboardVisible: (visible: boolean) => void;

  selectedElementIndex: number | null;
  setSelectedElementIndex: (index: number | null) => void;

  auditError: string | null;
  setAuditError: (error: string | null) => void;

  auditInProgress: boolean;
  setAuditInProgress: (value: boolean) => void;
}

export const useAuditStore = create<AuditStoreState>()((set) => ({
  selectedDevice: 'desktop',
  setSelectedDevice: (device) => set({ selectedDevice: device }),

  auditResult: null,
  setAuditResult: (result) => set({ auditResult: result }),

  selectedIssue: null,
  setSelectedIssue: (issue) => set({ selectedIssue: issue }),

  selectedIssueId: null,
  setSelectedIssueId: (id) => set({ selectedIssueId: id }),

  selectedIssueCategory: null,
  setSelectedIssueCategory: (category) => set({ selectedIssueCategory: category }),

  wcagFilter: '2.1_AA',
  setWcagFilter: (filter) => set({ wcagFilter: filter }),

  issueElement: null,
  setIssueElement: (element) => set({ issueElement: element }),

  isDashboardVisible: true,
  setIsDashboardVisible: (visible) => set({ isDashboardVisible: visible }),

  selectedElementIndex: null,
  setSelectedElementIndex: (index) => set({ selectedElementIndex: index }),

  auditError: null,
  setAuditError: (error) => set({ auditError: error }),

  auditInProgress: false,
  setAuditInProgress: (value) => set({ auditInProgress: value }),
}));

